import { useEffect, useState } from "react";

export interface ViewportBox {
  height: number;
  offsetTop: number;
}

const read = (): ViewportBox | null => {
  const vv = typeof window === "undefined" ? undefined : window.visualViewport;
  return vv ? { height: vv.height, offsetTop: vv.offsetTop } : null;
};

/**
 * Видимая часть экрана (window.visualViewport): на iOS клавиатура уменьшает
 * её, а 100dvh нет. null, если API нет или хук выключен.
 */
export function useVisualViewport(enabled: boolean): ViewportBox | null {
  const [box, setBox] = useState<ViewportBox | null>(() =>
    enabled ? read() : null
  );
  useEffect(() => {
    const vv = window.visualViewport;
    if (!enabled || !vv) {
      setBox(null);
      return;
    }
    const update = () => setBox(read());
    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, [enabled]);
  return box;
}
